
define('text!templates/message.html',[],function () { return '<div class="text-center full">\n    <div class="midalign helper"></div>\n    <div class="midalign block">\n        <div id="message"></div>\n        <div>\n            <a class="btn btn-custom" id="reloadButton"><i class="fa fa-refresh m-r-xs"></i> Reload</a>\n        </div>\n    </div>\n</div>';});

